import func from "../../services/functions";

export const internalStatusOptionsFn=(t,statistics) => [
    {
        key: "internalStatus",
        multiSelect: true,
        label: "DRAFT",
        count: statistics?.draftStatusInvoices,
        value: "Draft",
    },

    {
        key: "internalStatus",
        multiSelect: true,
        count: statistics?.approvalStatusInvoices,
        label: "APPROVAL",
        value: "Approval",
    },
    {
        key: "internalStatus",
        count: statistics?.financeStatusInvoices,
        multiSelect: true,
        label: t("purchases.finance").toUpperCase(),
        value: "Finance",
    },

    {
        key: "internalStatus",
        multiSelect: true,
        count: statistics?.refusedStatusInvoices,
        label: t("status.REFUSED").toUpperCase(),
        value: "Refused",
    },
    {
        key: "internalStatus",
        multiSelect: true,
        count: statistics?.acceptedStatusInvoices,
        label: t("queue.accepted").toUpperCase(),
        value: "Accepted",
    },
];

export const cisStatusOptionsFn=(t,statistics) => [
    {
        key: "purchaseStatus",
        count: statistics?.cisDeliveredStatusInvoices,
        multiSelect: true,
        label: func.capitalizeFirstLetter(t("status.DELIVERED")),
        value: "DELIVERED",
    },
    {
        key: "purchaseStatus",
        count: statistics?.cisAcceptedStatusInvoices,
        multiSelect: true,
        label: t("queue.accepted"),
        value: "ACCEPTED",
    },
    {
        key: "purchaseStatus",
        multiSelect: true,
        count: statistics?.cisRejectedStatusInvoices,
        label: t("purchases.rejected"),
        value: "REFUSED",
    },

    {
        key: "purchaseStatus",
        multiSelect: true,
        count: statistics?.cisPartiallyPaidStatusInvoices,
        label: func.capitalizeFirstLetter(t("status.PARTIALLY_PAID")),
        value: "PARTIALLY_PAID",
    },
    {
        key: "purchaseStatus",
        count: statistics?.cisPaidStatusInvoices,
        multiSelect: true,
        label: func.capitalizeFirstLetter(t("status.PAID")),
        value: "PAID",
    },
];

export const amountsFn=(t) => [
    {
        key: "amounts",
        label: t("invoice.approvals"),
        value: "approvals",
    },
    {
        key: "amounts",
        label: t("invoice.rejections"),
        value: "rejections",
    },
];

export const priorityOptionsFn=(t,statistics) => [
    {
        key: "priority",
        count: statistics?.lowPriorityInvoices,
        multiSelect: true,
        label: t("invoice.low"),
        value: "Low",
    },
    {
        key: "priority",
        count: statistics?.mediumPriorityInvoices,
        multiSelect: true,
        label: t("invoice.medium"),
        value: "Medium",
    },
    {
        key: "priority",
        count: statistics?.highPriorityInvoices,
        multiSelect: true,
        label: t("invoice.high"),
        value: "High",
    },
];

export const otherOptionsFn=(t,statistics) => [
    {
        key: "downloaded",
        count: statistics?.apiDownloaded,
        label: t("invoice.apiDownloaded"),
        value: "true",
    },
    {
        key: "profileId",
        count: statistics?.selfInvoiceNo,
        label: t("invoice.selfInvoice"),
        value: "P12",
      },
    {
        key: "profileId",
        count: statistics?.correctiveInvoice,
        label: t("invoice.correctiveInvoice"),
        value: "P9,P10",
      },
    {
        key: "purchasesWithAttachments",
        count: statistics?.purchasesWithAttachments,
        label: t("purchases.hasAttachments"),
        value: "true",
    },
]

export const uIOptionsFn=(t) => [
    { value: "eic", label: "EIC" },
    { value: "iic", label: t("invoice.IIC") },
    { value: "fic", label: t("invoice.FIC"), },
    { value: "docNumber", label: t("invoice.DocNumber") },
    { value: "sellerTin", label: t("invoice.sellerNuis") },
];

export const currencyOptionsFn=(statistics)=> [
    {
        key: "currency",
        count: statistics?.allCurrencyInvoices,
        multiSelect: true,
        label: "Lek",
        value: "ALL",
    },
    {
        key: "currency",
        multiSelect: true,
        count: statistics?.usdCurrencyInvoices,
        label: "USD",
        value: "USD",
    },
    {
        key: "currency",
        count: statistics?.eurCurrencyInvoices,
        multiSelect: true,
        label: "Euro",
        value: "EUR",
    },
];


export const prioritySortList={
  "Low":1,
  "Medium":2,
  "High":3
}

export const statusSortList = {
  "Draft":5,
  "Approval":4,
  "Refused":3,
  "Accepted":2,
  "Finance":1,
};

export const cisStatusList = {
  "DELIVERED":6,
  "ACCEPTED":5,
  "REFUSED":4,
  "OVERPAID":3,
  "PAID":2,
  "PARTIALLY_PAID":1,
};



export const allTcrFn =(company)=>{
    let tcrList = []
    if (!company?.branches) return tcrList
    company.branches
        .reduce((acc, branch) => branch?.tcrTypes?.length > 0 ? acc.concat(branch.tcrTypes) : acc, [])
        .forEach(tcr => {
            if (tcr?.allowPurchase) {
                let sellerName = company?.branches?.find((branch) => branch?.businUnitCode == tcr?.businUnitCode)?.sellerName ?? ""
                tcrList.push({ label: tcr.tcrCode + " - " + sellerName, value: tcr.tcrCode })
            }
        })
    return tcrList
}



export const tcrListFn = (businessUnitCode,businessUnitSelected,company, showSelectValue = true) => {
    let buCode = businessUnitCode || businessUnitSelected;

    company.branches.reduce((acc, branch) => branch?.tcrTypes?.length > 0 ? acc.concat(branch.tcrTypes) : acc, [])
    let branch = company.branches.find(branch => branch.businUnitCode == buCode)
    let tcrList = branch?.tcrTypes?.filter((tcrType) => tcrType?.allowPurchase).map((tcr) => {
        let sellerName = branch.sellerName
        return {
            label: tcr.tcrCode + "-" + sellerName,
            value: tcr.tcrCode,
        }
    }) ?? []

    return  tcrList
}
